
export function setSaveAsNewUrl(state, data) {
  state.saveAsNewUrl = data
}

export function setCurrentYear(state, data) {
    state.currentYear = data
}

export function setEndDate(state, data) {
    state.endDate = data
}

export function setStartDate(state, data) {
    state.startDate = data
}

export function setNewYear(state, data) {
    state.newYear = data
}







